<template>
  <div class="loginpop" v-if="visible">
    <div class="pop">
      <div class="img" @click="closeFn">
        <img src="@/assets/images/x.png" alt="close" />
      </div>
      <div class="logo">
        <img src="@/assets/images/logoT.png" alt="logo" />
      </div>
      <div class="content">
        <div class="liner">
          <i class="line"></i>
          <span>{{ $t("Signin.title") }}</span>
          <i class="line"></i>
        </div>
        <div class="inp-part">
          <span class="name">{{ $t("Signin.account") }}：</span>
          <div class="inp">
            <input
              type="text"
              v-model="user"
              :placeholder="$t('Signin.input')"
            />
          </div>
        </div>
        <div class="inp-part">
          <span class="name">{{ $t("Signin.password") }}：</span>
          <div class="inp"><input type="password" v-model="password" /></div>
        </div>

        <div class="login-mark">
          <span class="name">{{ $t("Signin.VerificationCode") }}：</span>
          <input type="text" v-model="code" />
          <img :src="imgSrc" alt=" " @click="getMark" />
        </div>

        <div class="btnbox">
          <div class="btn" @click="loginFn">{{ $t("Signin.login") }}</div>
        </div>
        <div class="fonts">
          <div class="l font1" @click="modify">
            {{ $t("Signin.Forgetpassword") }}？
          </div>

          <div class="r">
            <span>{{ $t("Signin.noaccount") }}</span>
            <span class="font1" @click="register">{{
              $t("Signin.Registernow")
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginPop",
  data() {
    return {
      num: "1",
      imgSrc: "",
      user: "",
      password: "",
      loginMark: "", //验证码标识
      code: "",
      visible: false,
    };
  },
  methods: {
    closeFn() {
      this.$emit("closePop", true);
      this.$closeLogin();
    },
    //获取验证码
    getMark() {
      let url = "/open/user/getVerifyCode";
      this.$get(url).then((res) => {
        this.imgSrc = res.data.base64Str;
        this.loginMark = res.data.loginMark;
      });
    },
    register() {
      this.$register();
    },
    modify() {
      this.$modifyPsd();
    },
    //登录方法
    loginFn() {
      let data = {
        code: this.code,
        loginMark: this.loginMark,
        email: this.user,
        password: this.password,
        params: {
          fromdata: true,
        },
      };
      let url = "/open/user/login";

      if (this.user != "" && this.password != "" && this.code != "") {
        this.$post(url, data).then((res) => {
          if (res.data.token) {
            sessionStorage.setItem("token", res.data.token);
            sessionStorage.setItem("user", JSON.stringify(res.data));
            location.reload();
          }
        });
      } else {
        this.$message({
          message: this.$t("Tips.perfect"),
          type: "error",
        });
      }
    },
  },
  created() {
    //获取验证码
    this.getMark();
    if (sessionStorage.getItem("token")) {
      this.is_login = false;
    }
  },
};
</script>
<style scoped>
.name {
  width: 100px;
}
.loginpop {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding-top: 204px;
}

.pop {
  width: 465px;
  height: 462px;
  margin: 0 auto;
  background: #fff;
  box-sizing: border-box;
  position: relative;
  padding-top: 22px;
}

.img {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 15px;
  top: 17px;
}

.logo {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo img {
  height: 70px;
}

.liner {
  display: flex;
  font-size: 14px;
  color: #666;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 43px;
}

.content {
  padding: 0 57px;
  width: 100%;
  box-sizing: border-box;
  padding-top: 24px;
}

.line {
  width: 100px;
  height: 1px;
  background: rgba(226, 226, 226, 1);
  display: inline-block;
}

.inp-part {
  font-size: 15px;
  color: #1a1a1a;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.inp {
  width: 279px;
  height: 32px;
  border: 1px solid rgba(226, 226, 226, 1);
  box-sizing: border-box;
  overflow: hidden;
}

input {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  padding-left: 10px;
  box-sizing: border-box;
}

.btnbox {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 17px;
  margin-top: 17px;
}

.btn {
  width: 299px;
  height: 32px;
  background: linear-gradient(
    0deg,
    rgba(5, 115, 203, 1) 0%,
    rgba(63, 159, 234, 1) 100%
  );
  color: #fff;
  font-size: 15px;
  line-height: 32px;
  text-align: center;
}

.fonts {
  font-size: 14px;
  color: #666;
  display: flex;
  justify-content: space-between;
}

.font1 {
  color: #0875cc;
}

.login-mark {
  margin-top: 24px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  color: #1a1a1a;
}

.login-mark > input {
  width: 48%;
  height: 32px;
  padding: 0 4px;
  border: 1px solid #e2e2e2;
}

.login-mark img {
  width: 30%;
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/assembly/LoginPop.vue